<template>
  <div>
    <Rate
      @change="rateChange"
      v-model="fileInf.obj.rateAvg"
      :disabled="disabled"
      :allow-half="allowHalf"
      :show-score="!$store.state.app.isMobile"
      :score-template="`${!$store.state.app.isMobile ? 'Контент үнэлэх' : ''}: ${fileInf.obj.rateAvg.toFixed(1)}`"
    >
    </Rate>
    <!-- <feather v-for="s in 5" :key="s" :class="{'text-warning': fileInf.obj.rateAvg>(s-1)}" @click="contentRate(fileInf.obj.id, s)" :role="disabled?'default':'button'" type="star" ></feather> -->
    <!-- <strong class="tx-rubik tx-12" v-if="fileInf.obj!=undefined && fileInf.obj.rateAvg!=undefined">
        {{fileInf.obj.rateAvg.toFixed(1)}}
    </strong> -->
  </div>
</template>

<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Rate } from "element-ui";

export default {
  components: {
    Rate
  },
  props: {
    fileInf: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    allowHalf: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    rateChange(e) {
      //console.log(e);
      if (!this.disabled) {
        request({
          api: { method: "post", url: "Media/RateContent" },
          data: { attachId: this.fileInf.obj.id, rate: e },
          store: this.$store
        }).then(res => {
          if (res != false) {
            //console.log(res);
            this.$emit("on-rate", { rate: e, avg: res.data.rateAvg });
            //this.fileInf.obj.myRate = rate;
            //this.fileInf.obj.rateAvg = res.data.rateAvg;
          }
        });
      }
    },
    contentRate(fileId, rate) {
      if (!this.disabled) {
        request({
          api: { method: "post", url: "Media/RateContent" },
          data: {
            attachId: fileId,
            rate: rate
          },
          store: this.$store
        }).then(res => {
          if (res != false) {
            //console.log(res);
            this.$emit("on-rate", { rate: rate, avg: res.data.rateAvg });
            //this.fileInf.obj.myRate = rate;
            //this.fileInf.obj.rateAvg = res.data.rateAvg;
          }
        });
      }
    }
  }
};
</script>

<style></style>
